import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../Service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const unrestrictedPaths = ['ventas','gastos','ingresos', 'saldos' , 'usuario/login' ];
    const currentUser = this.authService.getCurrentUser();
    
    if (currentUser != null) {
      if (currentUser.idpersonal.idnivel!=2 || unrestrictedPaths.includes(next.routeConfig.path)) {
        // El usuario es staff o la ruta es no restringida
        return true;
      } else {
        // El usuario no es staff y la ruta es restringida
        this.router.navigate(['/ventas']);
        return false;
      }
    } else {
      // El usuario no está autenticado
      this.router.navigateByUrl('/usuario/login');
      return false;
    }

  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
